import { Helmet } from "react-helmet-async";

const SITE = "https://azuregypsy.org";
const DEFAULT_IMG = `${SITE}/og-default.jpg`;
const DEFAULT_DESC = "Verified hobby farmers, local drivers, fresh produce direct to your door. Members order for free.";

/**
 * Per-page SEO and Open Graph tags.
 * Pass image as absolute URL (or omit for default).
 */
export default function Seo({ title, description, image, url, type = "website", noindex = false }) {
  const fullTitle = title
    ? `${title} — Azure Gypsy Farms`
    : "Azure Gypsy Farms — Real food. Real hobby farmers. Straight to your door.";
  const fullDesc = description || DEFAULT_DESC;
  const fullImage = image || DEFAULT_IMG;
  const canonical = url ? `${SITE}${url}` : SITE + "/";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={fullDesc} />
      <link rel="canonical" href={canonical} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}

      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={fullDesc} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={fullDesc} />
      <meta name="twitter:image" content={fullImage} />
    </Helmet>
  );
}
